import { useEffect, useState } from "react";

export enum NavigationTypeEnum {
  Reload = "reload",
  Navigate = "navigate",
  BackForward = "back_forward",
  Prerender = "prerender",
}

export function useNavigationType(): NavigationTypeEnum {
  const [type, setType] = useState<NavigationTypeEnum>(
    NavigationTypeEnum.Navigate
  );

  useEffect(() => {
    const entries = performance.getEntriesByType("navigation");

    if (!entries.length) return;

    const nav = entries[0] as PerformanceNavigationTiming;

    setType(nav.type as NavigationTypeEnum);
  }, []);

  return type;
}
